import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { API } from 'javascripts/api'
import { JobOffer, JobOfferDetail } from 'javascripts/api/generated'
import '../../../../javascript/i18n'
import styles from './JobOfferContentView.module.scss'
import { StyledLoadingOverlay } from 'spa/member/components/LoadingOverlay/styled'

interface JobOfferContentViewProps {
  jobOffer: JobOffer
}

const JobOfferContentView: React.FC<JobOfferContentViewProps> = (props) => {
  const { t } = useTranslation()
  const [jobOfferDetail, setJobOfferDetail] = useState<JobOfferDetail>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setIsLoading(true)
    API.getUserJobOfferDetail(props.jobOffer.id)
      .then(response => {
        setJobOfferDetail(response.data)
      })
      .catch(() => {
        setJobOfferDetail(null)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  if (isLoading) {
    return <StyledLoadingOverlay isOpen={isLoading} />
  }

  if (!jobOfferDetail) {
    return <div>{t('job_offer_details.not_found')}</div>
  }

  const officeLocation = () => {
    return [
      props.jobOffer.officeLocationPrefecture,
      props.jobOffer.officeLocation,
    ].filter(value => !!value)
  }

  return (
    <div className={styles.jobOfferContentView}>
      <h1>{props.jobOffer.title}</h1>
      <ul>
        { jobOfferDetail.clientName && <li>{jobOfferDetail.clientName}</li> }
        <li className={styles['-office-location']}>{officeLocation().join('、')}</li>
        <li className={styles['-occupation']}>{props.jobOffer.occupation?.name}</li>
        <li>
          <span className={styles.jobPriceS}>
            〜
            <span id='max_unit_price'>{t('number.default', { val: props.jobOffer.maxUnitPrice })}</span>
          </span>
          <div className={styles.jobPriceUnitS}>円／月（※月160時間稼働の場合・税別）</div>
        </li>
      </ul>
      <dl>
        <dt>稼働日数</dt>
        <dd>{jobOfferDetail.matchingWorkingDays.join('、')}</dd>
        <dt>常駐日数</dt>
        <dd>{jobOfferDetail.matchingResidentDays.join('、')}</dd>
        <dt>就業時間</dt>
        <dd className={styles['pre-wrap']}>{jobOfferDetail.workingHours}</dd>
      </dl>
      <h2>業務内容</h2>
      <div className={styles.textPre}>{props.jobOffer.description}</div>
      {props.jobOffer.productDescription && (
        <>
          <h2>関わるサービス・プロダクト</h2>
          <div className={styles.textPre}>{props.jobOffer.productDescription}</div>
        </>
      )}
      <h2>求められるスキル</h2>
      <div className={styles.textPre}>{props.jobOffer.requirement}</div>
      {jobOfferDetail.requirementSkills && (
        <>
          <br />
          <p>【歓迎スキル】</p>
          <div className={styles.textPre}>{jobOfferDetail.requirementSkills}</div>
        </>
      )}
      <h2>その他</h2>
      <dl>
        <dt>商流</dt>
        <dd>{jobOfferDetail.commercialDistribution}</dd>
        <dt>支払い方法（精算幅）</dt>
        <dd>{jobOfferDetail.paymentMethods.join('、')}</dd>
      </dl>
    </div>
  )
}

export default JobOfferContentView
